import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { DISPLAY_LANG } from "../../../config";
import { errorMessage } from "../../../api/global";
import axios from "../../../axios";
import SSLSingle from "../../../components/ssl/SSLSingle";
import Loading from "../../../components/loading";
import "../../../stylesheets/sslCategoryPage.css";


// ARTAK JAAAAAAAAN PAHEL DB-um
const sslBrands = [
  {
    name: "Comodo",
    heading: "Comodo SSL Certificates",
  },

  {
    name: "Sectigo",
    heading: "Sectigo SSL Certificates",
  },

  {
    name: "DigiCert",
    heading: "DigiCert SSL Certificates",
  },

  {
    name: "GeoTrust",
    heading: "GeoTrust SSL Certificates",
  },

  {
    name: "RapidSSL",
    heading: "RapidSSL Certificates",
  },

  {
    name: "Thawte",
    heading: "Thawte SSL Certificates",
  }
];


export default function SSLCategoryPage() {
  const [data, setData] = useState(null);
  const [products, setProducts] = useState(null);
  const [activeProductCode, setActiveProductCode] = useState(null);
  const [loading, setLoading] = useState(true);
  const [logoImage, setLogoImage] = useState(null);
  const [isCursorLoad, setIsCursorLoad] = useState(false);
  const { brand } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const loadingData = async () => {
      try {
        const res = await axios.get(`ssl/get_ssl_category?brand=${brand}&lang=${DISPLAY_LANG}`);
        const fetchedData = res.data.data;
        
        setData(fetchedData);

        const resLogo = await axios.get(`ssl/sll_image`);
        setLogoImage(resLogo.data.data);

        if (fetchedData && fetchedData.length > 0) {
          const firstProductCode = fetchedData.sort((a, b) => a.order - b.order)[0].productCode;
          setActiveProductCode(firstProductCode);

          localStorage.setItem("ssl_product_code", firstProductCode);

          const productRes = await axios.post(`ssl/products`, { product_code: firstProductCode });
          setProducts(productRes.data);
        }
      } catch (error) {
        console.log(error);
        alert(errorMessage[DISPLAY_LANG]);
      } finally {
        setLoading(false);
      }
    };

    loadingData();
    sessionStorage.removeItem("redirectAfterLogin");
  }, [brand]);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handlePostSSLType = async (product_code) => {
    setIsCursorLoad(true);

    try {
      const res = await axios.post(`ssl/products`, { product_code });
      setProducts(res.data);
      setActiveProductCode(product_code);
      localStorage.setItem("ssl_product_code", product_code);

    } catch (error) {
      console.log(error);
      alert(errorMessage[DISPLAY_LANG]);
    } finally {
      setIsCursorLoad(false);
    }
  };

  const currentBrand = sslBrands.find(
    (b) => b.name.toLowerCase() === brand?.toLowerCase()
  );

  const activeProduct = data?.find((el) => el.productCode === activeProductCode);

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="SSLCategoryPage wrapper" style={{ cursor: isCursorLoad ? 'wait' : 'default' }}>
      {currentBrand && (
        <div className="brand-header">
          <div className="ssl-brand-card">
            {
              logoImage.map((el) => (
                (el.brand_image_name === brand) ? (
                  <img
                    key={el.id}
                    src={el.image_url}
                    alt={`${el.brand_image_name} SSL Certificate Brand`}
                  />
                ) : null
              ))
            }
          </div>
          <h1 className="heading">{currentBrand.heading}</h1>
        </div>
      )}
      <div className="ssl-content-layout" style={{ cursor: isCursorLoad ? 'wait' : 'default' }}>
        <div className="ssl-cards-container" style={{ cursor: isCursorLoad ? 'wait' : 'default' }}>
          {data &&
            data
            .sort((a, b) => a.order - b.order)
            .map((el, index) => (
              <div

                className={`ssl-card ${activeProductCode === el.productCode ? 'active' : ''}`}
                key={index}
                onClick={() => handlePostSSLType(el.productCode)}
                style={{ cursor: isCursorLoad ? 'wait' : 'pointer' }}
              >
                <span className="productName">{el.productName}</span>
                <span className="arrow-icon">➜</span>
              </div>
            ))}
        </div>

        {
          activeProduct &&
          <SSLSingle
            activeProduct={activeProduct}
            products={products}
            brand={brand}
            data={data}
            navigate={navigate}
          />
        }
      </div>
    </div>
  );
}
